import React from "react";

export const InputLabel = React.memo(({ label = "", showOptional = false, id = "", labelStyle = {}, imgSrc = "" }) => (
    <label htmlFor={id} className="m-b-5">
        <span style={labelStyle}>{imgSrc ? <img src={imgSrc} style={{ objectFit: "contain" }} alt="radio" /> : label}</span>
        {showOptional && <span className="opt-field">(Optional)</span>}
    </label>
));